module.exports = __webpack_public_path__ + "static/media/CRC25.73b8b3e4.otf";